import React, { PureComponent } from 'react';
import classnames from 'classnames';


class Control extends PureComponent {
  static defaultProps = {
    type: 'checkbox',
    label: '',
    value: '1',
  };

  render() {
    const {
      checked,
      children,
      className,
      defaultChecked,
      disabled,
      id,
      label,
      name,
      type,
      value,
      onChange,
      onClick,
      onInput,
      onBlur,
      onFocus,
      required,
      style,
      readOnly,
    } = this.props;

    return (
      <label
        className={classnames(className, `icmib-input icmib-${type} d-ib`)}
        style={style}
      >
        <input
          checked={checked}
          className={`icmib-input__input icmib-${type}__input`}
          defaultChecked={defaultChecked}
          disabled={disabled}
          id={id}
          name={name}
          onChange={onChange}
          onClick={onClick}
          onInput={onInput}
          onBlur={onBlur}
          onFocus={onFocus}
          required={required}
          readOnly={readOnly}
          type={type}
          value={value}
        />
        <div
          className={`icmib-input__widget icmib-${type}__widget d-ib`}
          style={{
            verticalAlign: '-0.25em',
            marginRight: children || label ? null : 0,
          }}
        />
        {children ? (
          children
        ) : label ? (
          <span
            className="icmib-input__text"
            dangerouslySetInnerHTML={{ __html: label }}
          />
        ) : null}
      </label>
    );
  }
}

export default Control;
